import Kibo from './kibo'

export default { Kibo }
